export const INTEGRATION_KINDS = ['PAYMENT', 'ACCESS_CONTROL', 'EMAIL', 'STORAGE', 'SMS'] as const;
export type IntegrationKind = (typeof INTEGRATION_KINDS)[number];

export const INTEGRATION_STATUSES = [
  'NOT_CONFIGURED',
  'CONNECTED',
  'DEGRADED',
  'DISCONNECTED',
  'INVALID_CREDENTIALS',
  'ERROR',
] as const;
export type IntegrationStatus = (typeof INTEGRATION_STATUSES)[number];

export const PAYMENT_PROVIDERS = ['mock', 'tbc', 'bog'] as const;
export type PaymentProviderKey = (typeof PAYMENT_PROVIDERS)[number];

export const ACCESS_CONTROL_PROVIDERS = ['mock', 'enviso', 'gantner_agent'] as const;
export type AccessControlProviderKey = (typeof ACCESS_CONTROL_PROVIDERS)[number];

export const EMAIL_PROVIDERS = ['console', 'smtp', 'resend'] as const;
export type EmailProviderKey = (typeof EMAIL_PROVIDERS)[number];

export const EMAIL_SENDER_KINDS = ['GYM', 'PLATFORM', 'CONSOLE'] as const;
export type EmailSenderKind = (typeof EMAIL_SENDER_KINDS)[number];

export const STORAGE_PROVIDERS = ['local', 'supabase', 'r2'] as const;
export type StorageProviderKey = (typeof STORAGE_PROVIDERS)[number];

export const SMS_PROVIDERS = ['console', 'smsoffice'] as const;
export type SmsProviderKey = (typeof SMS_PROVIDERS)[number];

export const PROVIDERS_BY_KIND: Record<IntegrationKind, readonly string[]> = {
  PAYMENT: PAYMENT_PROVIDERS,
  ACCESS_CONTROL: ACCESS_CONTROL_PROVIDERS,
  EMAIL: EMAIL_PROVIDERS,
  STORAGE: STORAGE_PROVIDERS,
  SMS: SMS_PROVIDERS,
};

export const PAYMENT_RECORD_PROVIDERS = [...PAYMENT_PROVIDERS, 'manual'] as const;
export type PaymentRecordProvider = (typeof PAYMENT_RECORD_PROVIDERS)[number];

export const ACCESS_EVENT_PROVIDERS = [...ACCESS_CONTROL_PROVIDERS, 'manual'] as const;
export type AccessEventProvider = (typeof ACCESS_EVENT_PROVIDERS)[number];
